<template>
  <v-card>
    <v-card-text>
      <plan-selection @on-cancel="onCancel" @on-continue="onContinue" :wait-duration="5000" />
    </v-card-text>
  </v-card>
</template>

<script>

// eslint-disable-next-line no-undef
import StripeKeyHelper from "@/services/StripeKeyHelper";
import SegmentTracking from "@/services/SegmentTracking";
import ChargeApi from "@/aws/charge/ChargeApi"
import PlanSelection from "@/components/accounts/steps/PlanSelection"
import AndroidInterface from "@/services/AndroidInterface";

export default {
  name: "Subscribe",
  components: {PlanSelection},

  data() {
    return {
      stripe: null,
    }
  },

  async mounted() {
    await this.$store.state.accountLoadedPromise
    console.log(JSON.stringify(this.$store.state))


    let productToLoadStripeFor = process.env.VUE_APP_PRODUCT
    if(this.$store.getters.isSubscribed) {
      if(this.$store.state.account?.account?.product) {
        productToLoadStripeFor = this.$store.state.account.account.product
      } else {
        productToLoadStripeFor = 'truple'
      }
    }

    const key = StripeKeyHelper.getStripeKey(productToLoadStripeFor)
    this.stripe = Stripe(key)
    console.log(`stripe initialized with ${key}`)
  },

  methods: {

    onCancel() {
      console.log('onCancel')
      this.cancel()
    },
    async onContinue(selectedPlan) {
      console.log('onContinue ' + JSON.stringify(selectedPlan))

      SegmentTracking.track('AddPaymentInfo', {
        category: 'Checkout'
      })

      const installedFromGooglePlay = AndroidInterface.installedFromGooglePlay()
      console.log(`installedFromGooglePlay = ${installedFromGooglePlay}`)

      const applicationId = AndroidInterface.getApplicationId()
      console.log(`applicationId = ${applicationId}`)

      if(AndroidInterface.canUseGooglePlayForPurchases() &&
          (installedFromGooglePlay === true || installedFromGooglePlay === undefined || installedFromGooglePlay === null)
          &&
          (applicationId === 'com.camhart.netcountable' || applicationId === undefined || applicationId === null)) {

        AndroidInterface.purchaseThroughGooglePlay(
            selectedPlan.googlePlaySubscriptionId,
            selectedPlan.planCode,
            parseFloat(selectedPlan.price)
        )

        this.done()
      } else {
        //stripe

        let priceId = selectedPlan.priceId[process.env.VUE_APP_ENV]
        //call create stripe session
        let response = await ChargeApi.createSession(
            priceId,
            `${process.env.VUE_APP_HOST}/postpayment?waitForSubscription=true&newSubscription=true&subscriptionAmount=${encodeURIComponent(selectedPlan.price)}&subscriptionPlan=${encodeURIComponent(priceId)}`,
            `${process.env.VUE_APP_HOST}/account?subscribe=true&onlyAnnual=false`,
            this.$store.getters.shouldGetFreeTrialDueToReferrer,
            this.$store.state.coupon
        )
        let sessionResponse = await this.stripe.redirectToCheckout({
          sessionId: response.data.sessionId
        })

        this.done()
      }
    },
    done() {
      this.$emit('done')
    },
    cancel() {
      this.$emit('cancel')
    },
  }
}
</script>

<style scoped>

</style>
